import classnames from 'classnames';

// tslint:disable-next-line:export-name
export const classes = (component: string, ...classNames: (string | undefined)[]) =>
    classnames(`elc-${component}`, `js-${component}`, classNames);
